import React, { useEffect, useState } from "react"
import { useAppDispatch } from "../../../store"
import { setCurrentPage } from "../../../store/auth/authReducer"
import Table from "../../../components/Table/Table"
import LinearProgress from "@mui/material/LinearProgress"
import axios from "axios"
import { Link } from "react-router-dom"
import Button from "@mui/material/Button"
import Box from "@mui/material/Box"
import { logOut } from "../../../utils/logOut"
import { Fade, FormControl, InputLabel, MenuItem, Select, Typography } from "@mui/material"
import SimplifiedTable from "../../../components/Table/SimpleTable"
import TranslatedText from "../../../utils/Translate"
import { useSnackbar } from "../../../utils/SnackbarContext"
import { useSelector } from "react-redux"


export default function Branches() {
    const dispatch = useAppDispatch()
    const [tableData, setTableData] = useState([])
    const [loading, setLoading] = useState(false)
    const [startRow, setStartRow] = useState(0)
    const [pageRows, setPageRows] = useState(100)
    const [maxRows, setMaxRows] = useState(pageRows)
    const [totalRows, setTotalRows] = useState(0)
    const [partners, setPartners] = useState([])
    const [filterParams, setFilterParams] = useState({
        partnerbank: '',
    })

    const { showSnackbar } = useSnackbar();

    const accesslevel = useSelector(
        (state: any) => state.auth.authData.accesslevel
    )

    useEffect(() => {
        dispatch(setCurrentPage(`Branch list`))
    }, [dispatch]);



    //Get contact groups
    async function fetchData(params: object = {}) {
        setLoading(true)
        try {
            const response = await axios.get(`https://cardgarantsales.com/restapi/branch`, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                }, params: { ...params, startRow, maxRows, calculatetotalcount: true }
            })
            if (response.data !== null) {
                setTotalRows(+response.data[0].totalcount)
                setTableData(response.data.slice(1))
            }

            console.log(response.data);

            setLoading(false)
        } catch (error: any) {
            console.log(error);
            if (error.code === "ERR_BAD_REQUEST") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
            setLoading(false)
        }
    }

    //Get partners for Select field
    async function getPartners(params: object = {}) {
        try {
            const response = await axios.get(`https://cardgarantsales.com/restapi/partner`, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                }, params: params
            })
            console.log(response.data);
            setPartners(response.data)
        } catch (error: any) {
            console.log(error);
            if (error.message === "Request failed with status code 401") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
        }
    }

    useEffect(() => {
        // fetchData(filterParams)
        accesslevel === "5" && getPartners()
    }, [])

    //on load - fetch data
    useEffect(() => {
        setTimeout(() => fetchData(filterParams), 0)
    }, [startRow, maxRows])

    //Pagination buttons
    function handleBack() {
        if ((startRow - pageRows) < 0) {
            setStartRow(0)
            setMaxRows(pageRows)

        }
        else {
            setStartRow((prev) => prev - pageRows)
            setMaxRows((prev) => prev - pageRows)
        }
    }

    function handleNext() {

        setStartRow((prev) => prev + pageRows)
        setMaxRows((prev) => prev + pageRows)

    }

    function handleEnd() {

        setStartRow(totalRows % pageRows === 0 ? totalRows - pageRows : totalRows - (totalRows % pageRows))
        setMaxRows(totalRows % pageRows === 0 ? totalRows : totalRows - (totalRows % pageRows) + pageRows)

    }

    function handleStart() {

        setStartRow(0)
        setMaxRows(pageRows)

    }

    const totalPages = Math.ceil(totalRows / pageRows);
    const currentPage = Math.ceil(maxRows / pageRows);

    return (
        <Box sx={{ height: '86vh', display: 'flex', flexDirection: 'column', mr: 1 }}>
            <Box sx={{ mb: 3, alignItems: "center", display: 'flex', width: "100vw", justifyContent: "space-between" }}>
                <Link to='/branch' state={{ type: 'add' }}>
                    <Button size="small" sx={{ mr: 1 }} variant="outlined"><TranslatedText text={'Add Branch'} /></Button>
                </Link>
                 <Box sx={{ display: "flex", alignItems: "center", gap: 2, flexWrap: 'wrap', justifyContent: 'center', mr: 25 }}>
                    {accesslevel == '5' &&
                        <>
                            <FormControl>
                                <InputLabel size="small" id="simple-select-label"><TranslatedText text={'Partner'} /></InputLabel>
                                <Select sx={{ width: 223 }} labelId="simple-select-label" onChange={(e) => setFilterParams({ ...filterParams, partnerbank: e.target.value })} value={filterParams.partnerbank} variant="outlined" size="small" label={<TranslatedText text={'Partner'} />} >
                                    <MenuItem value={''}>All</MenuItem>
                                    {
                                        partners.map((el: any) => (
                                            <MenuItem key={el.id} value={el.id}>{el.partnerbankcode}</MenuItem>
                                        ))
                                    }
                                </Select>
                            </FormControl>
                            <Button onClick={() => fetchData(filterParams)} size="small" sx={{ mr: 1 }} variant="contained" > <TranslatedText text={'Apply'} /></Button>
                        </>
                    }
                </Box>
                <Box></Box>
            </Box>
            {loading ? <LinearProgress sx={{ width: "50%", marginTop: '33vh', marginLeft: 'auto', marginRight: 'auto' }} /> :
                <>
                    <SimplifiedTable rows={tableData} page={'branch'} />
                    <Fade in={!loading} timeout={300}>
                        <Box sx={{ display: 'flex', alignItems: "center", marginTop: 'auto' }}>
                            <Box sx={{ mt: 2 }}>
                                <Button disabled={startRow === 0} onClick={() => handleStart()} size="small" sx={{ mr: 1 }} variant="outlined" >{"<<"}</Button>
                                <Button disabled={startRow === 0} onClick={() => handleBack()} size="small" sx={{ mr: 1 }} variant="outlined" ><span>{'<'}&nbsp;</span> {<TranslatedText text={"Back"} />}</Button>
                                <Button disabled={maxRows >= totalRows} onClick={() => handleNext()} size="small" sx={{ mr: 1 }} variant="outlined" >{<TranslatedText text={'Next'} />}&nbsp;<span>{'>'}</span></Button>
                                <Button disabled={maxRows >= totalRows || tableData.length < pageRows} onClick={() => handleEnd()} size="small" sx={{ mr: 1 }} variant="outlined" >{">>"}</Button>
                            </Box>
                            <Typography sx={{ pt: 2, ml: 2 }}><TranslatedText text={'Rows on page:'} /> {pageRows}</Typography>
                            <Typography sx={{ pt: 2, ml: 2 }}>
                                <TranslatedText text={'Page:'} /> {currentPage} / {totalPages}
                            </Typography>
                            <Typography sx={{ pt: 2, ml: 2 }}><TranslatedText text={'Total rows:'} /> {totalRows}</Typography>
                        </Box>
                    </Fade>
                </>}
        </Box>
    )
}